import { Box, Tag } from '@factorialco/deprecated-design-system'

import { useTrainingMemberships } from 'modules/trainings/hooks/TrainingMemberships/useTrainingMemberships'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

interface Props {
  trainingId: string
  employeeId: string
}

export const AttendanceTag = ({ trainingId, employeeId }: Props) => {
  const { getTrainingAttendanceColor, getTrainingAttendanceTranslation } = useTrainingsDatatable()

  const { trainingMemberships } = useTrainingMemberships({
    trainingId: String(trainingId),
    employeeId: String(employeeId),
  })

  const trainingMembership = trainingMemberships.find(
    (membership) => membership.employeeId === String(employeeId)
  )

  if (!trainingMembership) return null

  return (
    <Box width="fit-content">
      <Tag
        leftItem="circle"
        showCircle
        type={getTrainingAttendanceColor(trainingMembership.status)}
      >
        {getTrainingAttendanceTranslation(trainingMembership.status)}
      </Tag>
    </Box>
  )
}
